"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageInline = void 0;
const react_1 = __importDefault(require("react"));
const ImageInline = (props) => {
    return (react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "M15.75 14.2499V3.74988C15.75 2.92488 15.075 2.24988 14.25 2.24988H3.75C2.925 2.24988 2.25 2.92488 2.25 3.74988V14.2499C2.25 15.0749 2.925 15.7499 3.75 15.7499H14.25C15.075 15.7499 15.75 15.0749 15.75 14.2499ZM6.675 10.4849L8.25 12.3824L10.575 9.38988C10.725 9.19488 11.025 9.19488 11.175 9.39738L13.8075 12.9074C13.995 13.1549 13.815 13.5074 13.5075 13.5074H4.515C4.2 13.5074 4.0275 13.1474 4.2225 12.8999L6.09 10.4999C6.2325 10.3049 6.5175 10.2974 6.675 10.4849Z", fill: "#707070" })));
};
exports.ImageInline = ImageInline;
